(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  /* Reveal product gallery + details on scroll */
  document.documentElement.classList.add('mv-pjs');

  const reveal = (el) => {
    if (!el) return;
    el.classList.add('mv-p-in');
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
  );

  const targets = document.querySelectorAll(
    '.mv-pjs .product-media, .mv-pjs .product-information, .mv-pjs [data-mv-pcro], .mv-pjs .product-recommendations-section'
  );
  targets.forEach((t) => io.observe(t));

  /* Animate price when variant changes */
  const priceEls = document.querySelectorAll('.price__regular, .price__sale, .product-price');
  const priceFlash = (el) => {
    el.classList.remove('mv-price-flash');
    void el.offsetWidth;
    el.classList.add('mv-price-flash');
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type !== 'childList' && m.type !== 'characterData') return;
      priceEls.forEach((el) => {
        if (el.isConnected) priceFlash(el);
      });
    });
  });

  priceEls.forEach((el) => {
    if (el && el.isConnected) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    }
  });

  /* Add-to-cart button micro-interaction */
  document.querySelectorAll('.add-to-cart-button, .product-form__submit').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.classList.add('mv-btn-press');
      setTimeout(() => btn.classList.remove('mv-btn-press'), 250);
    });
  });
})();
